export const ConnectionIcon = () => (
  <svg
    aria-hidden="true"
    width="144"
    height="144"
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
    <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
    <path
      d="M72 94.6667C74.9455 94.6667 77.3333 92.2789 77.3333 89.3333C77.3333 86.3878 74.9455 84 72 84C69.0544 84 66.6666 86.3878 66.6666 89.3333C66.6666 92.2789 69.0544 94.6667 72 94.6667Z"
      fill="#1B679B"
    />
    <path
      d="M62.612 79.7333C63.8447 78.5002 65.3083 77.5221 66.9191 76.8547C68.5299 76.1874 70.2564 75.8439 72 75.8439C73.7436 75.8439 75.4701 76.1874 77.0809 76.8547C78.6917 77.5221 80.1553 78.5002 81.388 79.7333L87.084 74.2466C83.0833 70.246 77.6572 67.9985 71.9993 67.9985C66.3415 67.9985 60.9154 70.246 56.9147 74.2466L62.612 79.7333Z"
      fill="#458BC4"
    />
    <path
      d="M52 69.3333C54.6262 66.7065 57.7442 64.6228 61.1758 63.2012C64.6075 61.7795 68.2855 61.0478 72 61.0478C75.7144 61.0478 79.3925 61.7795 82.8241 63.2012C86.2558 64.6228 89.3737 66.7065 92 69.3333L98.4 62.9333C94.9332 59.4662 90.8174 56.7159 86.2877 54.8395C81.758 52.9631 76.903 51.9973 72 51.9973C67.097 51.9973 62.242 52.9631 57.7122 54.8395C53.1825 56.7159 49.0667 59.4662 45.6 62.9333L52 69.3333Z"
      fill="#43A6DD"
    />
    <path
      d="M47.9999 97.3333C47.7363 97.3333 47.4785 97.255 47.2593 97.1085C47.0401 96.962 46.8692 96.7538 46.7683 96.5102C46.6675 96.2666 46.6411 95.9986 46.6925 95.7399C46.7439 95.4813 46.8708 95.2438 47.0573 95.0573L95.0573 47.0573C95.1802 46.93 95.3274 46.8284 95.49 46.7585C95.6527 46.6886 95.8277 46.6519 96.0047 46.6503C96.1818 46.6488 96.3573 46.6825 96.5212 46.7496C96.6851 46.8166 96.8339 46.9156 96.9591 47.0408C97.0843 47.166 97.1833 47.3149 97.2503 47.4787C97.3174 47.6426 97.3511 47.8181 97.3496 47.9952C97.348 48.1722 97.3113 48.3472 97.2414 48.5099C97.1715 48.6725 97.0699 48.8197 96.9426 48.9427L48.9426 96.9427C48.6926 97.1927 48.3535 97.3332 47.9999 97.3333Z"
      fill="#444444"
    />
  </svg>
)
